import React from "react";
import { Card } from "../modules/Subscription/Management";

export function SubscribersCardPage(props) {
  return <Card {...props} />;
}
